module.exports = __webpack_public_path__ + "static/img/login-bg.cc226b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg.png
// module id = I+RT
// module chunks = 1